import { useComputedColorScheme, useMantineColorScheme } from '@mantine/core';
import type { CompassCopy } from '../i18n';

export function ThemeSwitch({ copy }: { copy: CompassCopy }): React.JSX.Element {
  const computedColorScheme = useComputedColorScheme('dark', { getInitialValueInEffect: false });
  const { setColorScheme } = useMantineColorScheme();

  return (
    <div className="flex items-center gap-1 p-1 bg-white/5 border border-white/10 rounded-full">
      <button 
        className={`px-4 py-1.5 rounded-full font-geist font-bold text-[10px] uppercase tracking-widest transition-all flex items-center gap-2 border-none cursor-pointer ${computedColorScheme === 'light' ? 'bg-white text-[#030712]' : 'bg-transparent text-on-surface-variant hover:text-white'}`}
        onClick={() => setColorScheme('light')}
      >
        <span className="material-symbols-outlined text-[14px]">light_mode</span>
        {copy.lightTheme}
      </button>
      <button 
        className={`px-4 py-1.5 rounded-full font-geist font-bold text-[10px] uppercase tracking-widest transition-all flex items-center gap-2 border-none cursor-pointer ${computedColorScheme === 'dark' ? 'bg-white text-[#030712]' : 'bg-transparent text-on-surface-variant hover:text-white'}`}
        onClick={() => setColorScheme('dark')}
      >
        <span className="material-symbols-outlined text-[14px]">dark_mode</span>
        {copy.darkTheme}
      </button>
    </div>
  );
}
